export default "__VITE_ASSET__jjYW4TR___"